import React from "react";
import { Link } from "react-router-dom";
import "./ProductsHome.css";

const ProductsHome: React.FC = () => {
  return (
    <main className="product-home">
      <section className="product-home-hero">
        <div className="product-home-copyblock">
          <p className="product-home-eyebrow">Products</p>
          <h1 className="product-home-title">
            Build. Run. Grow.
            <span>All from One Platform.</span>
          </h1>
          <p className="product-home-copy">
            The Stellar product suite brings together connect, workspace, discovery, payments,
            cloud, and AI into one cohesive platform layer.
          </p>
          <div className="product-home-actions">
            <Link to="/products/connect" className="product-home-primary">
              Start Your Journey
            </Link>
            <a href="#product-grid" className="product-home-secondary">
              Explore Products
            </a>
          </div>
        </div>

        <div className="product-home-visual">
          <img src="/product-heroes/home.png" alt="" className="product-home-image" />
        </div>
      </section>

      <section id="product-grid" className="product-home-grid">
        <LinkCard title="Connect" href="/products/connect" accent="#2453ff" text="Acquire and engage founders and partners at scale." />
        <LinkCard title="Edge" href="/products/edge" accent="#1d7f3b" text="Workspace for docs, incorporation, grants, schemes and requests." />
        <LinkCard title="Discovery" href="/products/discovery" accent="#f46a12" text="Find leads, buyers, suppliers and opportunities." />
        <LinkCard title="Payments" href="/products/payments" accent="#6d33ff" text="Collect, reconcile and manage payments." />
        <LinkCard title="Cloud" href="/products/cloud" accent="#1378ff" text="Host, secure and scale digital operations." />
        <LinkCard title="AI Agents" href="/products/ai-agents" accent="#ff2e78" text="Autonomous and assisted AI employees for your business." />
      </section>
    </main>
  );
};

const LinkCard: React.FC<{ title: string; href: string; accent: string; text: string }> = ({ title, href, accent, text }) => (
  <Link to={href} className="product-home-card">
    <span className="product-home-card-accent" style={{ background: accent }} />
    <div>
      <h2>{title}</h2>
      <p>{text}</p>
    </div>
  </Link>
);

export default ProductsHome;
